module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/gamer-mobile-45e79122929fae4fb05425917557e28a.png";